import UserTypes from '../types/UserTypes';

const initialState = {
  isLoading: false,
  userData: [],
  userItemData: {},
  activeUserData: [],
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const user = (state = initialState, action) => {
  switch (action.type) {
    case UserTypes.GET_USER_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UserTypes.GET_USER_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userData: action.payload
      };
    case UserTypes.GET_USER_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        userData: []
      };

    case UserTypes.GET_USER_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UserTypes.GET_USER_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userItemData: action.payload
      };
    case UserTypes.GET_USER_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        userItemData: []
      };
    case UserTypes.GET_USER_ACTIVE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UserTypes.GET_USER_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeUserData: action.payload
      };
    case UserTypes.GET_USER_ACTIVE_ERROR:
      return {
        ...state,
        isLoading: false,
        activeUserData: []
      };

    case UserTypes.UPDATE_USER_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paging,
          sortingData: action.payload.sorting,
          keyword: action.payload.keyword
        }
      };
    default:
      return state;
  }
};
export default user;
